import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const configSelector = createSelector(rootSelector, s => s.config);
export const externalServicesSelector = createSelector(configSelector, s => s.externalServices);
